import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatWaitTime = (endAt: string | undefined | null): string => {
  if (!endAt) return '';

  const endAtDate = new Date(endAt);
  const now = new Date();
  const diff = endAtDate.getTime() - now.getTime();
  const seconds = Math.floor(diff / 1000);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours > 0) {
    return `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`;
  }
  if (minutes > 0) {
    return `${minutes}m`;
  }
  return `${seconds}s`;
};
